import React, { useEffect } from 'react';
import '../styles/Statistiques.css';

const HTML = `
<div class="topbar">
      <div class="breadcrumb">
        <span>Cambérène</span><span class="sep">/</span>
        <span>Admin</span><span class="sep">/</span>
        <b>Statistiques</b>
      </div>
      <div class="search">
        <span class="ic"></span>
        <input type="text" placeholder="Chercher une métrique, un rapport…" />
        <kbd>⌘ K</kbd>
      </div>
      <div class="top-actions">
        <button class="icon-btn">⚏</button>
        <button class="icon-btn">◉<span class="dot"></span></button>
        <a class="top-cta" href="#">↓ Exporter PDF</a>
      </div>
    </div>

    <div class="content">

      <!-- ============ PAGE HEAD ============ -->
      <div class="page-head">
        <div>
          <span style="font-family:var(--mono); font-size:11px; letter-spacing:.22em; text-transform:uppercase; color:var(--char-500)">Rapport · 19 Avr — 19 Mai 2026</span>
          <h1>Le pouls<br /><span class="ital">du village.</span></h1>
          <p class="sub">Vues, lectures, nouveaux membres, performance des chantiers et engagement de la diaspora — au mois, à la semaine, à la minute.</p>
        </div>
        <div style="display:flex; gap:10px; align-items:center; flex-wrap:wrap">
          <span class="live-pill"><span class="d"></span> Live · <b>847</b> en ligne</span>
          <div class="seg">
            <button>Jour</button>
            <button class="on">30 jours</button>
            <button>Trim.</button>
            <button>Année</button>
            <button>Tout</button>
          </div>
          <button class="pill-btn">⇆ Comparer</button>
          <button class="pill-btn">↓ Export</button>
        </div>
      </div>

      <!-- ============ KPI STRIP ============ -->
      <div class="kpis">
        <div class="kpi">
          <div class="lab">Pages vues · 30j</div>
          <b>308 412</b>
          <span class="delta up">▲ +18,4%</span>
          <svg class="spark" viewBox="0 0 90 38">
            <path d="M 0 28 L 10 26 L 20 22 L 30 24 L 40 18 L 50 14 L 60 10 L 70 12 L 80 6 L 90 4" fill="none" stroke="#E76F51" stroke-width="1.6"/>
          </svg>
        </div>
        <div class="kpi">
          <div class="lab">Visiteurs uniques</div>
          <b>47 280</b>
          <span class="delta up">▲ +12,1%</span>
          <svg class="spark" viewBox="0 0 90 38">
            <path d="M 0 24 L 10 22 L 20 18 L 30 20 L 40 16 L 50 12 L 60 8 L 70 10 L 80 4 L 90 6" fill="none" stroke="#1B6985" stroke-width="1.6"/>
          </svg>
        </div>
        <div class="kpi">
          <div class="lab">Membres actifs · 30j</div>
          <b>3 248</b>
          <span class="delta up">▲ +142</span>
          <svg class="spark" viewBox="0 0 90 38">
            <path d="M 0 30 L 10 28 L 20 24 L 30 22 L 40 18 L 50 16 L 60 12 L 70 10 L 80 8 L 90 4" fill="none" stroke="#34A853" stroke-width="1.6"/>
          </svg>
        </div>
        <div class="kpi dark">
          <div class="lab">Temps moyen / session</div>
          <b>4<span class="unit">min</span> 32<span class="unit" style="color:rgba(250,246,238,.4)">s</span></b>
          <span class="delta up" style="background:rgba(52,168,83,.2); color:#7CE39A">▲ +0:48</span>
          <svg class="spark" viewBox="0 0 90 38" style="opacity:.5">
            <path d="M 0 18 L 14 22 L 26 14 L 38 18 L 50 10 L 62 14 L 74 6 L 90 8" fill="none" stroke="#E2CB91" stroke-width="1.6"/>
          </svg>
        </div>
      </div>

      <!-- ============ TRAFFIC + SUMMARY ============ -->
      <div class="row r2">
        <section class="panel traffic">
          <div class="head">
            <div>
              <h3>Trafic du village</h3>
              <p class="sub">Vues, lectures complètes, et publications déposées · 30 derniers jours.</p>
            </div>
            <div class="actions">
              <button class="pill-btn on">Vues</button>
              <button class="pill-btn">Lectures</button>
              <button class="pill-btn">Publications</button>
              <button class="pill-btn">Engagement</button>
            </div>
          </div>

          <div class="chart">
            <svg viewBox="0 0 800 320" preserveAspectRatio="none">
              <defs>
                <linearGradient id="g1" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="0%" stop-color="#E76F51" stop-opacity=".3"/>
                  <stop offset="100%" stop-color="#E76F51" stop-opacity="0"/>
                </linearGradient>
                <linearGradient id="g2" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="0%" stop-color="#1B6985" stop-opacity=".22"/>
                  <stop offset="100%" stop-color="#1B6985" stop-opacity="0"/>
                </linearGradient>
              </defs>
              <!-- grid -->
              <g stroke="rgba(20,17,15,.06)" stroke-width="1">
                <line x1="0" y1="55"  x2="800" y2="55"/>
                <line x1="0" y1="125" x2="800" y2="125"/>
                <line x1="0" y1="195" x2="800" y2="195"/>
                <line x1="0" y1="265" x2="800" y2="265"/>
              </g>
              <g font-family="JetBrains Mono" font-size="9.5" fill="#807468" letter-spacing="1">
                <text x="6" y="50">20K</text>
                <text x="6" y="120">15K</text>
                <text x="6" y="190">10K</text>
                <text x="6" y="260">5K</text>
              </g>
              <!-- secondary (ocean) -->
              <path d="M 0 220 C 50 215, 90 205, 130 210 S 220 200, 260 185 S 350 195, 390 170 S 480 180, 520 160 S 600 165, 640 145 S 730 150, 800 140 L 800 320 L 0 320 Z" fill="url(#g2)"/>
              <path d="M 0 220 C 50 215, 90 205, 130 210 S 220 200, 260 185 S 350 195, 390 170 S 480 180, 520 160 S 600 165, 640 145 S 730 150, 800 140" fill="none" stroke="#1B6985" stroke-width="2"/>
              <!-- primary (sunset) -->
              <path d="M 0 180 C 50 160, 90 165, 130 145 S 220 160, 260 130 S 350 120, 390 105 S 480 100, 520 85 S 600 90, 640 70 S 730 50, 800 40 L 800 320 L 0 320 Z" fill="url(#g1)"/>
              <path d="M 0 180 C 50 160, 90 165, 130 145 S 220 160, 260 130 S 350 120, 390 105 S 480 100, 520 85 S 600 90, 640 70 S 730 50, 800 40" fill="none" stroke="#E76F51" stroke-width="2.5"/>
              <!-- markers -->
              <circle cx="640" cy="70" r="5" fill="#E76F51"/>
              <circle cx="640" cy="70" r="11" fill="none" stroke="#E76F51" stroke-opacity=".3"/>
              <!-- event marker -->
              <line x1="520" y1="20" x2="520" y2="300" stroke="#C9A961" stroke-width="1" stroke-dasharray="3 5" opacity=".7"/>
              <g transform="translate(528, 24)">
                <rect x="0" y="0" width="148" height="28" rx="6" fill="#C9A961"/>
                <text x="10" y="18" font-family="JetBrains Mono" font-size="9" letter-spacing="1.5" fill="#14110F">12 MAI · ASC FINALE</text>
              </g>
              <!-- tooltip -->
              <g transform="translate(560, 100)">
                <rect x="0" y="0" width="150" height="56" rx="10" fill="#14110F"/>
                <text x="14" y="18" font-family="JetBrains Mono" font-size="9" letter-spacing="1.5" fill="#E2CB91">15 MAI · VENDREDI</text>
                <text x="14" y="36" font-family="DM Sans" font-weight="500" font-size="12" fill="#FAF6EE">19 422 vues</text>
                <text x="14" y="50" font-family="JetBrains Mono" font-size="10" fill="#7DB3C5">12 188 lectures</text>
              </g>
              <!-- x-axis -->
              <g font-family="JetBrains Mono" font-size="9.5" fill="#807468">
                <text x="0" y="312">19 Avr</text>
                <text x="200" y="312">26 Avr</text>
                <text x="400" y="312">3 Mai</text>
                <text x="600" y="312">10 Mai</text>
                <text x="760" y="312">17 Mai</text>
              </g>
            </svg>
          </div>

          <div class="legend">
            <span><i style="background:#E76F51"></i>Vues totales</span>
            <span><i style="background:#1B6985"></i>Lectures complètes</span>
            <span><i style="background:#C9A961"></i>Événements clés</span>
            <span style="margin-left:auto">Total · 308 412 · ↑ 18,4 %</span>
          </div>

          <div class="compact">
            <div class="cell"><b>10 280</b>Vues / jour (moy.)</div>
            <div class="cell"><b>62,4 %</b>Lectures complètes</div>
            <div class="cell"><b>3,2</b>Pages / session</div>
            <div class="cell"><b>27,8 %</b>Taux de rebond</div>
          </div>
        </section>

        <section class="panel dark">
          <div class="head">
            <div>
              <h3 style="color:var(--bone)">Le mois en bref</h3>
              <p class="sub">Mai 2026 · résumé exécutif.</p>
            </div>
          </div>

          <div class="summary">
            <div>
              <div class="big">+18<span class="unit">%</span></div>
              <p class="desc">de croissance du trafic global vs. avril, porté par la finale de l'ASC, le Grand Appel et la rentrée du Studio Créatif.</p>
            </div>
            <div class="quick">
              <div><b>27</b><small>Articles publiés</small></div>
              <div><b>142</b><small>Nouveaux membres</small></div>
              <div><b>4</b><small>Diffusions live</small></div>
            </div>
          </div>

          <div class="foot">
            <span>Rapport établi le 19 Mai</span>
            <a href="#">Rapport complet →</a>
          </div>
        </section>
      </div>

      <!-- ============ AUDIENCE: DONUT + GEO + DEVICES ============ -->
      <div class="row r3">
        <section class="panel">
          <div class="head">
            <div>
              <h3>Composition de l'audience</h3>
              <p class="sub">Profil des visiteurs · 30 jours.</p>
            </div>
            <div class="actions"><button class="pill-btn">Détails</button></div>
          </div>

          <div class="donut-wrap">
            <svg class="donut-svg" viewBox="0 0 100 100">
              <circle cx="50" cy="50" r="40" fill="none" stroke="#F2EBDD" stroke-width="14"/>
              <!-- segments: habitants 42, diaspora 31, visiteurs 18, partenaires 9 -->
              <!-- circumference = 2*pi*40 ≈ 251.33 -->
              <circle cx="50" cy="50" r="40" fill="none" stroke="#E76F51" stroke-width="14"
                stroke-dasharray="105.56 145.77" stroke-dashoffset="0" transform="rotate(-90 50 50)"/>
              <circle cx="50" cy="50" r="40" fill="none" stroke="#1B6985" stroke-width="14"
                stroke-dasharray="77.91 173.42" stroke-dashoffset="-105.56" transform="rotate(-90 50 50)"/>
              <circle cx="50" cy="50" r="40" fill="none" stroke="#C9A961" stroke-width="14"
                stroke-dasharray="45.24 206.09" stroke-dashoffset="-183.47" transform="rotate(-90 50 50)"/>
              <circle cx="50" cy="50" r="40" fill="none" stroke="#34A853" stroke-width="14"
                stroke-dasharray="22.62 228.71" stroke-dashoffset="-228.71" transform="rotate(-90 50 50)"/>
              <text x="50" y="46" text-anchor="middle" font-family="Instrument Serif" font-size="22" fill="#14110F">47 280</text>
              <text x="50" y="60" text-anchor="middle" font-family="JetBrains Mono" font-size="6" letter-spacing="2" fill="#5A5048">VISITEURS · 30J</text>
            </svg>

            <div class="donut-legend">
              <div class="item"><i style="background:#E76F51"></i><b>Habitants</b><span class="v">19 858</span><span class="pct">42%</span></div>
              <div class="item"><i style="background:#1B6985"></i><b>Diaspora</b><span class="v">14 658</span><span class="pct">31%</span></div>
              <div class="item"><i style="background:#C9A961"></i><b>Visiteurs</b><span class="v">8 510</span><span class="pct">18%</span></div>
              <div class="item"><i style="background:#34A853"></i><b>Partenaires</b><span class="v">4 254</span><span class="pct">9%</span></div>
            </div>
          </div>

          <div class="foot">
            <span>Diaspora · +24,1 % vs avril</span>
            <a href="#">Segmenter →</a>
          </div>
        </section>

        <section class="panel">
          <div class="head">
            <div>
              <h3>Top 5 pays</h3>
              <p class="sub">D'où nous suit le village.</p>
            </div>
            <div class="actions"><button class="pill-btn">🗺 Carte</button></div>
          </div>

          <div class="geo-list">
            <div class="geo-item">
              <span class="flag">🇸🇳</span>
              <div>
                <div class="country">Sénégal</div>
                <div class="small">Dakar · St-Louis · Thiès</div>
                <div class="geo-bar"><i style="width:96%"></i></div>
              </div>
              <div class="v">31 248<small>66%</small></div>
            </div>
            <div class="geo-item">
              <span class="flag">🇫🇷</span>
              <div>
                <div class="country">France</div>
                <div class="small">Paris · Marseille · Lyon</div>
                <div class="geo-bar"><i style="width:38%"></i></div>
              </div>
              <div class="v">8 412<small>17,8%</small></div>
            </div>
            <div class="geo-item">
              <span class="flag">🇮🇹</span>
              <div>
                <div class="country">Italie</div>
                <div class="small">Milan · Bergame</div>
                <div class="geo-bar"><i style="width:18%"></i></div>
              </div>
              <div class="v">3 240<small>6,8%</small></div>
            </div>
            <div class="geo-item">
              <span class="flag">🇺🇸</span>
              <div>
                <div class="country">États-Unis</div>
                <div class="small">New York · Atlanta · DC</div>
                <div class="geo-bar"><i style="width:14%"></i></div>
              </div>
              <div class="v">2 482<small>5,2%</small></div>
            </div>
            <div class="geo-item">
              <span class="flag">🇪🇸</span>
              <div>
                <div class="country">Espagne</div>
                <div class="small">Madrid · Barcelone</div>
                <div class="geo-bar"><i style="width:9%"></i></div>
              </div>
              <div class="v">1 612<small>3,4%</small></div>
            </div>
          </div>

          <div class="foot">
            <span>42 pays au total</span>
            <a href="#">Voir tous →</a>
          </div>
        </section>

        <section class="panel">
          <div class="head">
            <div>
              <h3>Appareils &amp; canaux</h3>
              <p class="sub">Comment on accède au village.</p>
            </div>
          </div>

          <div class="devices">
            <div class="device">
              <div class="ic">▭</div>
              <b>72%</b>
              <small>Mobile</small>
              <div class="pct">▲ +6 pts</div>
            </div>
            <div class="device">
              <div class="ic">▢</div>
              <b>22%</b>
              <small>Desktop</small>
              <div class="pct" style="color:#B72333">▼ -4 pts</div>
            </div>
            <div class="device">
              <div class="ic">▱</div>
              <b>6%</b>
              <small>Tablette</small>
              <div class="pct">▲ +0.5 pt</div>
            </div>
          </div>

          <h4 style="font-family:var(--mono); font-size:10.5px; letter-spacing:.2em; color:var(--char-500); margin:22px 0 12px; text-transform:uppercase">Sources de trafic</h4>
          <div class="bar-list">
            <div class="bar-row">
              <span class="nm">Recherche organique <small>Google · Bing</small></span>
              <span class="v">38<small>%</small></span>
              <div class="track"><i class="sunset" style="width:38%"></i></div>
            </div>
            <div class="bar-row">
              <span class="nm">Réseaux sociaux <small>IG · FB · TT</small></span>
              <span class="v">27<small>%</small></span>
              <div class="track"><i class="ocean" style="width:27%"></i></div>
            </div>
            <div class="bar-row">
              <span class="nm">Direct <small>URL tapée</small></span>
              <span class="v">18<small>%</small></span>
              <div class="track"><i class="gold" style="width:18%"></i></div>
            </div>
            <div class="bar-row">
              <span class="nm">Newsletter <small>email</small></span>
              <span class="v">12<small>%</small></span>
              <div class="track"><i class="ok" style="width:12%"></i></div>
            </div>
            <div class="bar-row">
              <span class="nm">Référence <small>blogs · presse</small></span>
              <span class="v">5<small>%</small></span>
              <div class="track"><i class="sunset" style="width:5%; opacity:.5"></i></div>
            </div>
          </div>
        </section>
      </div>

      <!-- ============ HEATMAP + LIVE NOW ============ -->
      <div class="row r12">
        <section class="panel">
          <div class="head">
            <div>
              <h3>Quand le village est-il connecté ?</h3>
              <p class="sub">Sessions par jour de semaine × heure (UTC+0 · Dakar).</p>
            </div>
            <div class="actions">
              <button class="pill-btn on">Cette semaine</button>
              <button class="pill-btn">Moyenne mois</button>
            </div>
          </div>

          <div id="heatmap" class="heatmap" aria-label="Heatmap d'activité"></div>

          <div class="heatmap-foot">
            <span>Heures :</span>
            <span style="opacity:.7">00 · 06 · 12 · 18 · 24</span>
            <span style="margin-left:auto; display:flex; gap:10px; align-items:center">
              Intensité
              <div class="scale">
                <span style="background:#F2EBDD"></span>
                <span style="background:#FDE2D4"></span>
                <span style="background:#F8B697"></span>
                <span style="background:#E76F51"></span>
                <span style="background:#A93D29"></span>
              </div>
            </span>
            <span>Pic · Vendredi 18h–22h</span>
          </div>
        </section>

        <section class="panel dark">
          <div class="head">
            <div>
              <h3 style="color:var(--bone)">En ligne · maintenant</h3>
              <p class="sub">Mis à jour il y a 4 secondes.</p>
            </div>
          </div>

          <div class="live-now" style="margin-top:14px">
            <svg class="ring" viewBox="0 0 100 100">
              <circle cx="50" cy="50" r="42" fill="none" stroke="rgba(255,255,255,.08)" stroke-width="6"/>
              <circle cx="50" cy="50" r="42" fill="none" stroke="#34A853" stroke-width="6"
                stroke-dasharray="186 264" stroke-linecap="round" transform="rotate(-90 50 50)"/>
              <circle cx="50" cy="50" r="42" fill="none" stroke="#E2CB91" stroke-width="6"
                stroke-dasharray="44 264" stroke-dashoffset="-186" stroke-linecap="round" transform="rotate(-90 50 50)"/>
              <text x="50" y="56" text-anchor="middle" font-family="Instrument Serif" font-size="22" fill="#FAF6EE">847</text>
            </svg>
            <div>
              <div style="display:flex; align-items:center; gap:8px"><span style="width:8px; height:8px; border-radius:50%; background:#34A853; display:inline-block; box-shadow:0 0 0 0 rgba(52,168,83,.5); animation:pulse 1.8s infinite"></span><span class="lab">En direct</span></div>
              <p class="desc">Pic local : 847 personnes consultent le village. La diffusion ASC vs Yoff capte 42% du trafic temps réel.</p>

              <div class="where">
                <div class="row"><span>Match en direct</span><b>356</b></div>
                <div class="row"><span>Page d'accueil</span><b>187</b></div>
                <div class="row"><span>Galerie</span><b>94</b></div>
                <div class="row"><span>Talents</span><b>72</b></div>
                <div class="row"><span>Newsletter inscription</span><b>43</b></div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <!-- ============ TOP CONTENT + CATEGORIES ============ -->
      <div class="row r12">
        <section class="panel">
          <div class="head">
            <div>
              <h3>Contenus les plus consultés</h3>
              <p class="sub">Top 6 sur la période · mai 2026.</p>
            </div>
            <div class="actions">
              <button class="pill-btn on">Articles</button>
              <button class="pill-btn">Galerie</button>
              <button class="pill-btn">Talents</button>
              <button class="pill-btn">Commerces</button>
            </div>
          </div>

          <div class="toplist">
            <div class="toplist-row">
              <span class="rank gold">01</span>
              <span class="pict" style="background-image:url('https://picsum.photos/seed/cb-news-jeunes/120/120')"></span>
              <div class="meta"><b>Vingt jeunes lancent leur studio créatif</b><small>Jeunesse · 4 min · Aminata Diop</small></div>
              <div class="val">14 826<small>vues · 7,2 min lect.</small></div>
            </div>
            <div class="toplist-row">
              <span class="rank">02</span>
              <span class="pict" style="background-image:url('https://picsum.photos/seed/cb-news-mosquee/120/120')"></span>
              <div class="meta"><b>Préparatifs du Grand Appel — calendrier &amp; rites</b><small>Spirituel · 3 min · Cheikh L.</small></div>
              <div class="val">9 240<small>vues · 5,8 min lect.</small></div>
            </div>
            <div class="toplist-row">
              <span class="rank">03</span>
              <span class="pict" style="background-image:url('https://picsum.photos/seed/cb-gal-foot/120/120')"></span>
              <div class="meta"><b>Cheikh Diop · capitaine, 92 buts</b><small>Talent · sport · profil</small></div>
              <div class="val">7 102<small>vues · 4,1 min lect.</small></div>
            </div>
            <div class="toplist-row">
              <span class="rank">04</span>
              <span class="pict" style="background-image:url('https://picsum.photos/seed/cb-news-plage/120/120')"></span>
              <div class="meta"><b>Plage propre : 380 kg retirés en un samedi</b><small>Environnement · 2 min · Yacine Ba</small></div>
              <div class="val">5 612<small>vues · 3,2 min lect.</small></div>
            </div>
            <div class="toplist-row">
              <span class="rank">05</span>
              <span class="pict" style="background-image:url('https://picsum.photos/seed/cb-tour-plage/120/120')"></span>
              <div class="meta"><b>Plage Nord — golden hour, 1.8 km de sable</b><small>Tourisme · destination</small></div>
              <div class="val">4 318<small>vues · 2,1 min lect.</small></div>
            </div>
            <div class="toplist-row">
              <span class="rank">06</span>
              <span class="pict" style="background-image:url('https://picsum.photos/seed/cb-gal-procession/120/120')"></span>
              <div class="meta"><b>1978 : la grande procession blanche en archives</b><small>Histoire · long format</small></div>
              <div class="val">3 821<small>vues · 6,4 min lect.</small></div>
            </div>
          </div>
        </section>

        <section class="panel">
          <div class="head">
            <div>
              <h3>Par catégorie</h3>
              <p class="sub">Répartition des vues · mai.</p>
            </div>
          </div>

          <div class="cat-bar">
            <i style="background:#E76F51; width:28%"></i>
            <i style="background:#1B6985; width:22%"></i>
            <i style="background:#C9A961; width:18%"></i>
            <i style="background:#34A853; width:14%"></i>
            <i style="background:#7DB3C5; width:10%"></i>
            <i style="background:#807468; width:8%"></i>
          </div>

          <div class="cat-legend">
            <div class="item"><i style="background:#E76F51"></i><b>Jeunesse</b><span class="v" style="font-family:var(--serif); font-size:16px">86k</span><span class="pct">28%</span></div>
            <div class="item"><i style="background:#1B6985"></i><b>Spirituel</b><span class="v" style="font-family:var(--serif); font-size:16px">68k</span><span class="pct">22%</span></div>
            <div class="item"><i style="background:#C9A961"></i><b>Sport · ASC</b><span class="v" style="font-family:var(--serif); font-size:16px">55k</span><span class="pct">18%</span></div>
            <div class="item"><i style="background:#34A853"></i><b>Environnement</b><span class="v" style="font-family:var(--serif); font-size:16px">43k</span><span class="pct">14%</span></div>
            <div class="item"><i style="background:#7DB3C5"></i><b>Tourisme</b><span class="v" style="font-family:var(--serif); font-size:16px">31k</span><span class="pct">10%</span></div>
            <div class="item"><i style="background:#807468"></i><b>Histoire</b><span class="v" style="font-family:var(--serif); font-size:16px">25k</span><span class="pct">8%</span></div>
          </div>

          <h4 style="font-family:var(--mono); font-size:10.5px; letter-spacing:.2em; color:var(--char-500); margin:24px 0 12px; text-transform:uppercase">Talents les plus suivis</h4>
          <div class="bar-list">
            <div class="bar-row">
              <span class="nm">Aïssatou N'Diaye <small>Musique</small></span>
              <span class="v">12 408</span>
              <div class="track"><i class="sunset" style="width:96%"></i></div>
            </div>
            <div class="bar-row">
              <span class="nm">Cheikh Diop <small>Football</small></span>
              <span class="v">9 240</span>
              <div class="track"><i class="ocean" style="width:74%"></i></div>
            </div>
            <div class="bar-row">
              <span class="nm">Fatou Laye <small>Mode · Atelier Tassou</small></span>
              <span class="v">6 102</span>
              <div class="track"><i class="gold" style="width:48%"></i></div>
            </div>
            <div class="bar-row">
              <span class="nm">Modou Sarr <small>Pêcheur · doyen</small></span>
              <span class="v">3 488</span>
              <div class="track"><i class="ok" style="width:28%"></i></div>
            </div>
          </div>
        </section>
      </div>

      <!-- ============ FUNNEL + CIVIC ============ -->
      <div class="row r-funnel">
        <section class="panel">
          <div class="head">
            <div>
              <h3>Parcours diaspora → membre</h3>
              <p class="sub">Conversion des visiteurs internationaux en membres actifs.</p>
            </div>
            <div class="actions">
              <button class="pill-btn">Segmenter</button>
              <button class="pill-btn">Comparer · Avr</button>
            </div>
          </div>

          <div class="funnel">
            <div class="fstep">
              <div class="bar" style="width:100%"></div>
              <span class="idx">01</span>
              <div><div class="nm">Visite — page d'accueil</div><div class="desc">Hero, marquee, hero CTA</div></div>
              <div class="right"><div class="v">22 408</div><div class="pct">100% · base</div></div>
            </div>
            <div class="fstep">
              <div class="bar" style="width:78%"></div>
              <span class="idx">02</span>
              <div><div class="nm">Exploration — au moins 3 pages</div><div class="desc">Découvre, talents, ASC</div></div>
              <div class="right"><div class="v">17 478</div><div class="pct up">78,0 %</div></div>
            </div>
            <div class="fstep">
              <div class="bar" style="width:46%"></div>
              <span class="idx">03</span>
              <div><div class="nm">Inscription newsletter</div><div class="desc">Bandeau bas + section ASC</div></div>
              <div class="right"><div class="v">10 308</div><div class="pct up">46,0 %</div></div>
            </div>
            <div class="fstep">
              <div class="bar" style="width:22%"></div>
              <span class="idx">04</span>
              <div><div class="nm">Création de compte</div><div class="desc">Auth · OAuth ou email</div></div>
              <div class="right"><div class="v">4 926</div><div class="pct up">22,0 %</div></div>
            </div>
            <div class="fstep">
              <div class="bar" style="width:14%"></div>
              <span class="idx">05</span>
              <div><div class="nm">Première contribution</div><div class="desc">Commentaire, photo, soutien</div></div>
              <div class="right"><div class="v">3 142</div><div class="pct up">14,0 %</div></div>
            </div>
          </div>

          <div class="foot">
            <span>Conversion visite → membre : 22 % (↑ +3,4 pts)</span>
            <a href="#">Analyser →</a>
          </div>
        </section>

        <section class="panel civic">
          <div class="head">
            <div>
              <h3>Mairie · indicateurs civiques</h3>
              <p class="sub">Mai 2026 · suivi des engagements municipaux.</p>
            </div>
          </div>

          <div class="stat">
            <div class="nm">Délai moyen de traitement<small>Signalements habitants</small></div>
            <div class="v">32<small style="font-family:var(--mono); font-size:10px; opacity:.6">heures</small></div>
          </div>
          <div class="stat">
            <div class="nm">Taux de résolution<small>Sur 247 signalements ce mois</small></div>
            <div class="v" style="color:#1F7A3A">87<small>%</small></div>
          </div>
          <div class="stat">
            <div class="nm">Chantiers en cours<small>Sur les 4 mandats prioritaires</small></div>
            <div class="v">5 / 7</div>
          </div>
          <div class="stat">
            <div class="nm">Budget engagé · 2026<small>Sur enveloppe 1,4 Md FCFA</small></div>
            <div class="v">62<small>%</small></div>
          </div>
          <div class="stat">
            <div class="nm">Participation conseil municipal<small>Séance ordinaire 12 mai</small></div>
            <div class="v">214<small style="color:#1F7A3A">↑ record</small></div>
          </div>
          <div class="stat">
            <div class="nm">Réclamations résolues sous 48h<small>Voirie, eau, déchets</small></div>
            <div class="v" style="color:#1F7A3A">74<small>%</small></div>
          </div>
        </section>
      </div>

      <!-- ============ ASC + NEWSLETTER ============ -->
      <div class="row r2">
        <section class="panel">
          <div class="head">
            <div>
              <h3>ASC Cambérène — saison 2025/26</h3>
              <p class="sub">32 matchs joués · qualifiée pour la finale régionale.</p>
            </div>
            <div class="actions"><button class="pill-btn">Détails saison</button></div>
          </div>

          <div style="display:grid; grid-template-columns:auto 1fr; gap:32px; align-items:center; margin-bottom:18px">
            <svg viewBox="0 0 100 100" style="width:140px; height:140px; flex:none">
              <circle cx="50" cy="50" r="40" fill="none" stroke="#F2EBDD" stroke-width="14"/>
              <!-- 22V / 6N / 4D = 62.92, 17.16, 11.44 of 251.33 -->
              <circle cx="50" cy="50" r="40" fill="none" stroke="#34A853" stroke-width="14" stroke-dasharray="172.79 78.54" transform="rotate(-90 50 50)"/>
              <circle cx="50" cy="50" r="40" fill="none" stroke="#C9A961" stroke-width="14" stroke-dasharray="47.12 204.21" stroke-dashoffset="-172.79" transform="rotate(-90 50 50)"/>
              <circle cx="50" cy="50" r="40" fill="none" stroke="#E63946" stroke-width="14" stroke-dasharray="31.42 219.91" stroke-dashoffset="-219.91" transform="rotate(-90 50 50)"/>
              <text x="50" y="48" text-anchor="middle" font-family="Instrument Serif" font-size="22" fill="#14110F">32</text>
              <text x="50" y="62" text-anchor="middle" font-family="JetBrains Mono" font-size="6" letter-spacing="2" fill="#5A5048">MATCHS</text>
            </svg>

            <div style="display:grid; grid-template-columns:repeat(4, 1fr); gap:12px">
              <div><div style="font-family:var(--serif); font-size:38px; line-height:1; color:#1F7A3A">22</div><small style="font-family:var(--mono); font-size:10px; letter-spacing:.18em; color:var(--char-500); text-transform:uppercase">Victoires</small></div>
              <div><div style="font-family:var(--serif); font-size:38px; line-height:1; color:#8E6A12">6</div><small style="font-family:var(--mono); font-size:10px; letter-spacing:.18em; color:var(--char-500); text-transform:uppercase">Nuls</small></div>
              <div><div style="font-family:var(--serif); font-size:38px; line-height:1; color:#B72333">4</div><small style="font-family:var(--mono); font-size:10px; letter-spacing:.18em; color:var(--char-500); text-transform:uppercase">Défaites</small></div>
              <div><div style="font-family:var(--serif); font-size:38px; line-height:1">92</div><small style="font-family:var(--mono); font-size:10px; letter-spacing:.18em; color:var(--char-500); text-transform:uppercase">Buts marqués</small></div>
            </div>
          </div>

          <table class="table">
            <thead><tr><th>Statistique</th><th>ASC Cambérène</th><th>Moy. ligue</th><th>Écart</th></tr></thead>
            <tbody>
              <tr><td>Buts / match</td><td><b>2,9</b></td><td>1,7</td><td style="color:#1F7A3A">+1,2</td></tr>
              <tr><td>Possession moyenne</td><td><b>58 %</b></td><td>50 %</td><td style="color:#1F7A3A">+8 pts</td></tr>
              <tr><td>Cartons jaunes</td><td><b>14</b></td><td>22</td><td style="color:#1F7A3A">-8</td></tr>
              <tr><td>Spectateurs / match</td><td><b>4 218</b></td><td>2 480</td><td style="color:#1F7A3A">+70 %</td></tr>
              <tr><td>Direct vidéo · vues moy.</td><td><b>12 408</b></td><td>—</td><td style="color:#1F7A3A">★ leader</td></tr>
            </tbody>
          </table>
        </section>

        <section class="panel">
          <div class="head">
            <div>
              <h3>Newsletter · santé</h3>
              <p class="sub">Lettre du village · mensuelle.</p>
            </div>
          </div>

          <div style="font-family:var(--serif); font-size:64px; line-height:1; letter-spacing:-.02em; margin-bottom:6px">3 218</div>
          <div style="font-family:var(--mono); font-size:11px; letter-spacing:.2em; color:var(--char-500); text-transform:uppercase">Abonnés actifs · ▲ +218 ce mois</div>

          <div class="bar-list" style="margin-top:24px">
            <div class="bar-row">
              <span class="nm">Taux d'ouverture <small>moy. industrie 21%</small></span>
              <span class="v">52<small>%</small></span>
              <div class="track"><i class="sunset" style="width:52%"></i></div>
            </div>
            <div class="bar-row">
              <span class="nm">Taux de clic <small>moy. industrie 2,6%</small></span>
              <span class="v">14<small>%</small></span>
              <div class="track"><i class="ocean" style="width:14%"></i></div>
            </div>
            <div class="bar-row">
              <span class="nm">Désabonnement <small>moy. industrie 0,4%</small></span>
              <span class="v">0,2<small>%</small></span>
              <div class="track"><i class="ok" style="width:8%"></i></div>
            </div>
            <div class="bar-row">
              <span class="nm">Partages <small>via lien dédié</small></span>
              <span class="v">8,4<small>%</small></span>
              <div class="track"><i class="gold" style="width:34%"></i></div>
            </div>
          </div>

          <div class="foot">
            <span>Prochaine édition · 1 Juin</span>
            <a href="#">Préparer →</a>
          </div>
        </section>
      </div>

    </div>
`;

const Statistiques = () => {
  useEffect(() => {
    // Filter chips behavior (shared pattern from mockups)
    const groups = document.querySelectorAll('.admin-page .seg, .admin-page .filterbar');
    const handler = (e) => {
      const c = e.target.closest('.chip, .seg button, .pill-btn');
      if (!c) return;
      const group = c.parentElement;
      if (!group) return;
      const siblings = group.querySelectorAll('.chip, button');
      let sameGroup = true;
      siblings.forEach((s) => { if (!group.contains(s)) sameGroup = false; });
      if (sameGroup) {
        siblings.forEach((s) => s.classList.remove('on'));
        c.classList.add('on');
      }
    };
    groups.forEach((g) => g.addEventListener('click', handler));
    return () => groups.forEach((g) => g.removeEventListener('click', handler));
  }, []);

  return (
    <div className="admin-page admin-page-statistiques" dangerouslySetInnerHTML={{ __html: HTML }} />
  );
};

export default Statistiques;
